// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import _isFunction from 'lodash/isFunction';
import { Dialog, Container } from '@material-ui/core';
import { setRecentSearch } from 'utils';

const ProfileSearchTemplate = ({
  handleClose,
  profileData,
  history,
  clientSearchRenderer,
  accountSelectRenderer,
  customClientSelect,
}) => {
  const [cmdUri, setCmdUri] = React.useState('');
  const [step, setStep] = React.useState(0);

  const setPrevStep = () => setStep(0);
  const setNextStep = () => setStep(1);

  const handleClientSelect = _isFunction(customClientSelect)
    ? customClientSelect
    : (client = {}) => {
        setRecentSearch(`${client.firstName} ${client.lastName}`, client);
        setCmdUri(client.profileId);
        history.replace({
          search: '',
        });
      };

  const profileProps = {
    cmdUri,
    setCmdUri,
    profileData,
  };

  const currentStepDictionary = [
    () => clientSearchRenderer({ setNextStep, handleClientSelect, handleClose, ...profileProps }),
    () => accountSelectRenderer({ setPrevStep, ...profileProps }),
  ];

  return (
    <Dialog open fullScreen scroll="body" onClose={handleClose} data-testid="profile-search">
      <Container disableGutters maxWidth="sm" style={{ height: 'inherit' }}>
        {currentStepDictionary[step]()}
      </Container>
    </Dialog>
  );
};

ProfileSearchTemplate.propTypes = {
  handleClose: PropTypes.func,
  profileData: PropTypes.shape({}),
  history: PropTypes.shape({
    replace: PropTypes.func,
  }),
  clientSearchRenderer: PropTypes.func.isRequired,
  accountSelectRenderer: PropTypes.func.isRequired,
  customClientSelect: PropTypes.func,
};

ProfileSearchTemplate.defaultProps = {
  handleClose: () => {},
  profileData: {},
};

export default ProfileSearchTemplate;
